import { render, staticRenderFns } from "./RatebaseIndex.vue?vue&type=template&id=1e603b93&scoped=true&"
import script from "./RatebaseIndex.vue?vue&type=script&lang=js&"
export * from "./RatebaseIndex.vue?vue&type=script&lang=js&"
import style0 from "./RatebaseIndex.vue?vue&type=style&index=0&id=1e603b93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e603b93",
  null
  
)

export default component.exports